module.exports = __webpack_public_path__ + "media/images/flavours/icon-boise_dark-e1ad45a69f456fee551b9ccf6195503e.png";